import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { FuelChangesService } from '../../../services/fuel-changes.service';
import { FuelKpiRequest } from '../../../../_shared';
import { KpiFactorResponse } from '../../../../_shared/models/fuel-kpi-factor-response.model';
import { FactorTableComponent } from '../../../../_shared/components/factor-table/factor-table.component';
import { ErrorHandlerService } from '../../../../../_shared/services/error-handler.service';

@Component({
  selector: 'app-fuel-consumption-modal',
  standalone: true,
  imports: [FactorTableComponent],
  templateUrl: './fuel-consumption-modal.component.html',
  styleUrl: './fuel-consumption-modal.component.scss'
})
export class FuelConsumptionModal implements OnInit, OnDestroy {
  request: FuelKpiRequest;
  modalFilterHeaders: any;
  factorsData: KpiFactorResponse[] = [];
  formatters = {
    "Avg Consumption": (value: number): string => `${value.toFixed(2)}%`,
    "Best Asset": (value: string): string => value ?? 'N/A',
    "Worst Asset": (value: string): string => value ?? 'N/A',
    "Variance Across Fleet": (value: number): string => `${value.toFixed(0)}ℓ`
  };

  private cancelSubject: Subject<void> = new Subject<void>();

  constructor(
    private fuelChangesService: FuelChangesService,
    private errorHandlerService: ErrorHandlerService
  ) { }

  ngOnInit(): void {
    this.getFuelConsumptionKpiFactors();
  }

  async getFuelConsumptionKpiFactors(): Promise<void> {
    try {
      const response = await this.fuelChangesService.getFuelConsumptionKpiFactors(this.request, this.cancelSubject);
      this.factorsData = response.data ?? [];
    } catch (error: any) {
      this.errorHandlerService.handleError(error);
    }
  }

  ngOnDestroy(): void {
    this.cancelSubject.next();
    this.cancelSubject.complete();
  }
}